<template>
<div class="chapter">
<div class="inner_page">
<p class="part" id="parta1"><a href="#/toc#part1"><b>[ PART ONE ]</b></a></p>
<p class="part-tt"><a href="#/toc">CHECKPOINT</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781569479674_Split5.vue?46fdc6ec